import { Icon } from '@advanza/ui'
import * as Popover from '@radix-ui/react-popover'
import { useState } from 'react'

interface ChurnDetailsCellProps {
    reason: string | null
    comment: string | null
}

/**
 * Compact "Churn details" cell: a chevron button that opens a popover with the
 * full churn reason and (potentially long) churn comment, keeping the table row
 * narrow while still exposing the free-text fields on demand.
 */
const ChurnDetailsCell = ({ reason, comment }: ChurnDetailsCellProps) => {
    const [open, setOpen] = useState(false)

    if (!reason && !comment) {
        return <span className="text-neutral-400">-</span>
    }

    return (
        <Popover.Root open={open} onOpenChange={setOpen}>
            <Popover.Trigger asChild>
                <button
                    type="button"
                    className="inline-flex items-center gap-1 rounded border border-solid border-grey-500 bg-white px-2 py-0.5 text-sm font-medium hover:bg-grey-200">
                    Details
                    <Icon name="expand_more" fontSize={16} />
                </button>
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content
                    align="end"
                    sideOffset={4}
                    className="z-50 max-w-[360px] rounded-md border border-solid border-grey-500 bg-white p-3 shadow-md">
                    <div className="flex flex-col gap-3">
                        <div className="flex flex-col gap-0.5">
                            <span className="text-sm font-bold uppercase tracking-wide text-grey-700">
                                Churn Reason
                            </span>
                            <span className="text-md text-grey-900">{reason || '-'}</span>
                        </div>
                        <div className="flex flex-col gap-0.5">
                            <span className="text-sm font-bold uppercase tracking-wide text-grey-700">
                                Comment
                            </span>
                            <span className="whitespace-pre-wrap break-words text-md text-grey-900">
                                {comment || '-'}
                            </span>
                        </div>
                    </div>
                    <Popover.Arrow className="fill-white" />
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    )
}

export default ChurnDetailsCell
